﻿import Common from './i247.Common.js';
import VE103 from './i247.VE103.js';
import { _utilities } from "./utilities.js";

export let _ve103Form;

let vehicleLookup;

export default class VehicleLookup {
    constructor () {
        // local fields
        this._vehicle = undefined;

        // Class initialization
        this.BindFormControls();

       if ($('#ServiceIdentifier').val() === 'VE103') {
           _ve103Form = new VE103();
       }
    }

    // --------------------------------------------------
    // GETTER AND SETTER
    // --------------------------------------------------

    get Vehicle () {
        return this._vehicle;
    }

    set Vehicle (newVehicle) {
        this._vehicle = newVehicle;
    }

    // --------------------------------------------------
    // FUNCTIONS
    // --------------------------------------------------

    BindFormControls () {
        let _this = this;
        if ($('#ServiceIdentifier').val()) {
            $('#vehicle-search-input').focus();
        } else {
            $('#Registration').focus();
        }

        $('.i247service .fa-info-circle').click(function () {
            var windowText = $(this).data('infotext');
            var windowTitle = $(this).data('infotitle');
            var infoWindow = $('#infoWindow').kendoWindow({
                width: 'auto',
                height: 'auto',
                position: {
                    top: 100
                }
            }).data('kendoWindow');
            infoWindow.title(windowTitle);
            infoWindow.content(windowText);
            infoWindow.center().open();
        });

        $('#ButtonSearchAgain').click(function () {
            $('#PrivacyStatement').hide();
            $('#SearchAgain').hide();
            $('#ServiceList').hide();
            $('#ServicesHeader').hide();
            $('#SearchForm').show();
        });

        $('#PrivacyCheckBox').change(function () {
            if ($(this).is(':checked')) {
                _this.BindServiceButtons(true);
            } else {
                _this.BindServiceButtons(false);
            }
        });
    };

    GetVehicle (vehicleRegistration, grecaptcharesponse) {
        let result = $.Deferred();

		// send the q as well, which has the customer id in it to filter the vehicles returned.
		let queryString = Common.GetQueryStringValue('q', null);
        let url = '/vehicle/GetVehicle?q=' + queryString + '&vehicleRegistration=' + vehicleRegistration + '&grecaptcharesponse=' + grecaptcharesponse;

        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: function (data) {
                result.resolve(data);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($('body'), false);
                Common.ShowGenericError();
            },
            complete: function () {
            }
        });

        return result.promise();
    };

    GetVehicleServices(vehicleRegistration) {
        var result = $.Deferred();
        var url = '/vehicle/GetServices?vehicleRegistration=' + vehicleRegistration;
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: function (data) {
                result.resolve(data);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($('body'), false);
                Common.ShowGenericError();
            },
            complete: function () {
            }
        });

        return result.promise();
    };

    GetDriverCompanySettings(driverCompanyId) {
        let result = $.Deferred();

        let url = '/foreigntravel/GetDriverCompanySettings?&driverCompanyId=' + driverCompanyId;

        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            success: function (data) {
                result.resolve(data);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(xhr.responseText);
                console.log(thrownError);
                kendo.ui.progress($('body'), false);
                Common.ShowGenericError();
            },
            complete: function () {
            }
        });

        return result.promise();
    };

    DoLookup (registration, grecaptcharesponse) {
        let _this = this;
        var serviceIdentifier = $('#ServiceIdentifier').val();

        $.get("/foreigntravel/CustomerLink")
            .fail(function () {
                Common.ShowGenericError();
            })
            .done(function (customer) {

            if (serviceIdentifier) {
                kendo.ui.progress($('body'), true);

                Common.HideUserMessage();

                const registration = $('#vehicle-search-input').val().replace(' ', '').toUpperCase();
                let label = (customer.name.substring(0, 1).toUpperCase() === 'A') ? 'an' : 'a';
                let serviceText = (serviceIdentifier === 'VE103') ? 'Customer Service' : 'Tyres';
                let customerName = '';
                switch (customer.name) {
                    case 'Omodaandjaecoo':
                        customerName = "Omoda and Jaecoo Contract Hire"
                        break;

                    case 'Mg':
                        customerName = 'MG Contract Hire';
                        break;

                    case 'Hyundai':
                        customerName = 'Hyundai Contract Hire';
                        break;

                    case 'Honda':
                        customerName = 'Honda Contract Hire';
                        break;

                    case 'Byd':
                        customerName = 'BYD';
                        break;

                    default:
                        customerName = customer.name;
                        break;
                }
                let vehicleNotFoundMessage = `<p>Sorry no vehicle details are currently held against registration ${registration}. Please check the registration entered and try again.</p><p>If registration still doesn’t validate, check this is definitely ${label} ${customerName} vehicle, contact the Driverline and select the option for ${serviceText}, one of the team will then call you to assist.</p><p><a class="btn btn-success" href="javascript:window.location.href=window.location.href">Try again</a></p>`;

                _this.GetVehicle(registration, grecaptcharesponse).done(function (vehicle) {
                    if (!vehicle) {
                        Common.ShowUserMessage('Vehicle Not Found', vehicleNotFoundMessage, true);
                        kendo.ui.progress($('body'), false);
                        return;
                    }

                    _this.ShowCallMe();
                    _this.Vehicle = vehicle;

                    // isAllowedAbroad Msg
                    if (serviceIdentifier === 'VE103' && _this.Vehicle.isAllowedAbroad != '1' && _this.Vehicle.isAllowedAbroad != null) {
                        var msg = {
                            title: '',
                            body: ''
                        }
                        switch (_this.Vehicle.isAllowedAbroad) {
                            case 0:
                                msg.title = 'Vehicle Not Allowed Abroad';
                                msg.body = SITE_NOT_ALLOWED_MSG;
                                break;
                            case 2:
                                msg.title = 'Authorisation Required';
                                msg.body = SITE_AUTHORISATION_MSG;
                                break;
                        }
                        Common.ShowUserMessage(msg.title, msg.body, false);
                        $('#fullPageContainer').hide();
                        kendo.ui.progress($('body'), false);
                        return;
                    }

                    _this.GetDriverCompanySettings(_this.Vehicle.driverCompanyId).done(function (settings) {
                        var greenCardText = settings.filter(option => option.sysName.toUpperCase() === 'GREENCARDTEXT')[0];
                        if (greenCardText !== undefined) {
                            $('#dcs_greenCardText').html(greenCardText.settingValue);
                        }
                    });

                    _this.GetVehicleServices(_this.Vehicle.registration).done(function (services) {
                        if (services.length === 0 || services.indexOf(serviceIdentifier) === -1) {
                            $('#no-services-found-for-vehicle-message').show();
                            $('#ServicesHeader').hide();
                            kendo.ui.progress($('body'), false);
                        } else {
                            $('#ServicesHeader').show();
                            $('#no-services-found-for-vehicle-message').hide();

                            if (serviceIdentifier === 'VE103') {
                                _ve103Form.SetVehicle(_this.Vehicle);
                                _ve103Form.Initialise();
                            }
                        }
                    });

                    if (_this.Vehicle.mileageCheckSuppression) {
                        $('#mileageContainer').hide();
                    }
                });
            } else {
                $('#PrivacyCheckBox').attr('checked', false);

                kendo.ui.progress($('body'), true);

                Common.HideUserMessage();
                $('#ServicesHeader').hide();
                $('#ServiceList').hide();

                _this.GetVehicle(registration, grecaptcharesponse).done(function (vehicles) {
                    if (!vehicle) {
                        Common.ShowUserMessage('Vehicle Not Found', vehicleNotFoundMessage, true);
                        _this.ShowCallMe();
                        kendo.ui.progress($('body'), false);
                        return;
                    }

                    var selectedServiceUrl = $('#SelectedServiceUrl').val();
                    if (selectedServiceUrl !== '') {
                        window.location = selectedServiceUrl;
                        return;
                    }

                    _this.Vehicle = vehicles[0];

                    _this.GetVehicleServices(_this.Vehicle.registration).done(function (services) {
                        kendo.ui.progress($('body'), false);

                        $('.i247service').hide();
                        $('#SearchAgain').hide();
                        $('#ServiceList').hide();
                        $('#PrivacyStatement').hide();

                        if (services.length === 0) {
                            Common.ShowUserMessage('Unable to Proceed', `<p>We could not find any services associated with vehicle registration ${_this.Vehicle.registration}.</p><p>Please call your dedicated Driverline for assistance.</p>`, true);
                            return;
                        } else {
                            $('#PrivacyStatement').show();
                            $('#ServicesHeader').show();
                            $('#HeaderRegistration').text(registration.toUpperCase());
                            $('#HeaderVehicleMake').text(_this.Vehicle.manufacturer);
                            $('#HeaderVehicleDescription').text(_this.Vehicle.description);
                            $('#HeaderVehicleLeaseCompany').text(_this.Vehicle.customerName);
                            $('#HeaderVehicleDriverCompany').text(_this.Vehicle.driverCompanyName);
                            $('#SearchAgain').show();
                            $('#SearchForm').hide();
                        }

                        $.each(services, function (i, service) {
                            var selector = '#DIV' + service.toUpperCase();
                            $(selector).show();
                        });
                    });
                });
            }
        });
    };

    ShowCallMe() {
        _utilities.LoadHtmlTemplate('/ForeignTravel/GetEmailForm', {},
            async function (template) {
                $('#email-helper').html(template);
                Common.InitialiseEmailSupportTab();
            });
    }

    BindServiceButtons (ShowService) {
        $('.i247service .gobutton').unbind('click');

        if (ShowService) {
            $('#ServiceList').slideDown();
            $('.i247service .gobutton').click(function () {
                window.location = $(this).data('url');
            });
        } else {
            $('#ServiceList').slideUp();
            $('.i247service .gobutton').click(function () {
                if (!$('#PrivacyCheckBox').is(':checked')) {
                    $('#PrivacyCheckBox').kendoTooltip({
                        width: 240,
                        position: 'top',
                        animation: {
                            open: {
                                effects: 'zoom',
                                duration: 150
                            }
                        }
                    }).data('kendoTooltip').show();
                }
            });
        }
    }
};

// Google Captcha Callback (Needs to be in global scope)
function RecaptchaCallBack (result) {
    let validator = $('#VehicleSearchFormContainer').kendoValidator().data('kendoValidator');
    Common.BindValidationStyles(validator);

    let recaptchaResponse = grecaptcha.getResponse();

    if (!validator.validate()) return;

    let registration = $('#Registration').val();

    if ($('#ServiceIdentifier').val()) {
        registration = $('#vehicle-search-input').val();
    }
    registration = registration.replace(' ', '');

    grecaptcha.reset();
    vehicleLookup.DoLookup(registration, recaptchaResponse);
};

$(function () {
    vehicleLookup = new VehicleLookup();

    window.grecaptcha.ready(() => {
        grecaptcha.render('vehicle-search-button', {
            'sitekey': '6LecsgkbAAAAAB6gO3yIsno1RUQoGE3VXB3rEjX3',
            'callback': RecaptchaCallBack
        })
    });
});